import React, { useEffect } from 'react';
import { renderMenuBlock, removeMenuBlock } from './menu-blocks';

export interface MenuBlockProps {
    type: string;
}

export function MenuBlock({ type }: MenuBlockProps): JSX.Element {
    const ref = React.createRef<HTMLDivElement>();
    useEffect(() => {
        if (ref.current) renderMenuBlock(ref.current, type);
        return () => {
            removeMenuBlock(type);
        };
    }, [ref.current, type]);
    return <div ref={ref} />;
}
